import Network from '@/services/network'
import { ref } from 'vue'

export default function handleJournal() {
    const network = new Network;
    const loading = ref(false)

    const fetchJournals = (query) => {
      return network.api('get', '/reports/ledger-master' + query);
    }

    const fetchJournal = (ledgerMasterId, query = '') => {
      return network.api('get', '/ledgers/'+ledgerMasterId+query);
    }

    const createJournal = (data) => {
      return network.api('post', '/ledgers', data);
    }

    const handleApproval = (data) => {
      return network.api('post', '/ledgers/approval', data);
    }

    const editJournal = (id,data) => {
      return network.api('post', '/ledgers/'+id, data);
    }

    const fetchAccountHeads = (companyId, cash_bank_hide='') => {
      return network.api('get', `/account-heads?company_id=${companyId}&cash_bank_hide=${cash_bank_hide}`);
    }

    const fetchAccountHeadsList = (query) => {
      return network.api('get', '/account-heads'+ query);
    }

    const fetchUploadedJournals = (query) => {
      return network.api('get', '/ledgers/upload/list'+ query);
    }

    const uploadJournal = (data) => {
      return network.api('post', '/ledgers/upload', data);
    }

    const fetchSheet = (id, query) => {
      return network.api('get', '/ledgers/upload/'+id+query);
    }

    const updateIndividual = (id, data) => {
      return network.api('post', '/ledgers/update/voucher/'+id, data);
    }

    const removeIndividual = (id, data) => {
        return network.api('post', `/ledgers/remove-individual/voucher/`+id, data);
    }

    const storeIndividual = (id, data) => {
      return network.api('post', '/ledgers/store/voucher/'+id, data);
    }

    const removeUploaded = (id, companyId) => {
      return network.api('delete', `/ledgers/delete/voucher/${id}?company_id=${companyId}`);
    }

    const storeCashBankIndividual = (id, data) => {
        return network.api('post', '/ledgers/store/cash-bank/'+id, data);
    }

    const updateCashAndBankIndividual = (id, data) => {
        return network.api('post', '/ledgers/update/cash-bank/'+id, data);
    }

    const uploadCashAndBankTransaction = (data) => {
        return network.api('post', '/ledgers/upload-cash-bank', data);
    }

    return {
        fetchJournals,
        removeUploaded,
        storeIndividual,
        fetchSheet,
        updateIndividual,
        uploadJournal,
        removeIndividual,
        fetchUploadedJournals,
        fetchJournal,
        createJournal,
        fetchAccountHeads,
        fetchAccountHeadsList,
        editJournal,
        handleApproval,
        loading,
        storeCashBankIndividual,
        updateCashAndBankIndividual,
        uploadCashAndBankTransaction,
    }
}
